import { atom } from "recoil";

import { Language } from "graphql/generated";
import keys from "src/states/constants";

export const opsLocaleState = atom<Language>({
  key: keys.OPS_LOCALE_STATE,
  default: Language.En
});
